import { Result } from "antd";
export default Result;
